import { useSnackbar } from 'vue3-snackbar';
type SnackbarType = 'info' | 'error' | 'warning';

interface Snackbar {
  add: (a: { type?: SnackbarType; text: string; duration?: number }) => void;
}

export default useSnackbar as () => Snackbar;
